/* istanbul ignore file */
import seatmapManagerFactory from './seatmap-manager-factory';

export default seatmapManagerFactory;
